import { render, staticRenderFns } from "./SetOrderTags.vue?vue&type=template&id=194ce743"
import script from "./SetOrderTags.vue?vue&type=script&lang=js"
export * from "./SetOrderTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports